import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { HighlightedAttribute } from 'wsm-highlighted-attribute';
import HighlightedAttributeItem from './HighlightedAttributeItem';

const HighlightedAttributeContainer = ({ accountInfo }) => {
	const {
		enableLocationHighlight,
		enableFuelTypeHighlight,
		highlightedFuelTypeElectricIcon,
		highlightedFuelTypeHybridIcon
	} = usePrefs();
	const isEnabled =
		enableLocationHighlight === 'true' ||
		enableFuelTypeHighlight === 'true';

	if (isEnabled) {
		return (
			<div
				className={setClassNames([
					'vehicle-card-highlight',
					'mb-3',
					'align-self-start',
					'd-flex',
					'flex-wrap'
				])}
			>
				{enableLocationHighlight === 'true' && (
					<HighlightedAttributeItem
						title={accountInfo.name}
						address={accountInfo.address}
						phone={accountInfo.phone}
						id={accountInfo.id}
						icon="ddc-icon-map"
					/>
				)}
				{enableFuelTypeHighlight === 'true' && (
					<HighlightedAttribute
						title={accountInfo.fuelType}
						electricIcon={highlightedFuelTypeElectricIcon}
						hybridIcon={highlightedFuelTypeHybridIcon}
						type="fuelType"
					/>
				)}
			</div>
		);
	}
	return null;
};

HighlightedAttributeContainer.propTypes = {
	accountInfo: PropTypes.shape({
		name: PropTypes.string,
		address: PropTypes.shape({}),
		phone: PropTypes.string,
		id: PropTypes.string,
		fuelType: PropTypes.string
	}).isRequired
};

export default HighlightedAttributeContainer;
